import { useState, useEffect, useCallback } from 'react';
import { getCards } from '~/components/Card/service/api';

interface CardItem {
  cod_card: number;
  des_card: string;
  cor: string;
  cor_texto: string;
  cod_card_fixado: number;
  tipo_acesso: number;
  cod_usuario: number;
  usuario: string;
}

interface UseCardsListReturn {
  cards: CardItem[];
  loading: boolean;
  refetchCards: () => Promise<void>;
}

export const useCardsList = (
  codTela: number,
  tipoAcesso = 0,
): UseCardsListReturn => {
  const [cards, setCards] = useState<CardItem[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchCards = useCallback(async () => {
    if (!codTela) return;

    setLoading(true);
    try {
      const response = await getCards(codTela, tipoAcesso);

      if (response.success && response.data) {
        setCards(response.data);
      } else {
        setCards([]);
      }
    } catch (error) {
      console.error('Erro ao buscar cards:', error);
      setCards([]);
    } finally {
      setLoading(false);
    }
  }, [codTela, tipoAcesso]);

  useEffect(() => {
    fetchCards();
  }, [fetchCards]);

  return { cards, loading, refetchCards: fetchCards };
};
